import React, { useMemo } from "react";
import styles from "./Style.module.css";
import { MenuItem, ListItemIcon, Typography } from "@material-ui/core";
import { People, Info, ExitToApp, Delete } from "@material-ui/icons";
import useGroupMenuHook from "./GroupMenu.hook";
import GroupCreate from "../GroupCreate/GroupCreate.view";
import SidePanelComponent from "../../../../../components/SidePanel/SidePanel.component";
import DeleteDialog from "../GroupCreate/component/DeleteDialog/DeleteDialog";
import GroupDetail from "../GroupCreate/GroupDetail.view";

const GroupMenu = ({
  groupId,
  handleClosepopOver,
  isGroupAdmin,
  setChatUser,
  fetchChatInfo,
  isAuditAdmin,
  isAdminCoAdmin,
  renderConversation,
  groupMemberList = [],
}) => {
  const {
    sidePanel,
    handleSideToggle,
    isDelete,
    toggleDeleteDialog,
    handleDelete,
    exitDialog,
    toggleExitDialog,
    handleCloseSidePanel,
    sidePanelType,
    handleExit,
    coAdminDialog,
    toggleCoAdminDialog,
  } = useGroupMenuHook({ groupId, setChatUser, handleClosepopOver });

  return (
    <div className={styles.menuContainer}>
      {sidePanel && (
        <SidePanelComponent
          handleToggle={handleCloseSidePanel}
          title={
            coAdminDialog
              ? "Add Co-Admin"
              : sidePanelType === "UPDATE"
              ? `${groupId ? "Update" : "Create"} Group`
              : "Group Details"
          }
          open={sidePanel}
          side={"right"}
        >
          {sidePanelType === "UPDATE" ? (
            <GroupCreate
              groupId={groupId}
              key={groupId}
              handleSidePanelToggle={handleCloseSidePanel}
              handleClosepopOver={handleClosepopOver}
              fetchChatInfo={fetchChatInfo}
              setChatUser={setChatUser}
            />
          ) : sidePanelType === "DETAIL" ? (
            <GroupDetail
              groupId={groupId}
              handleUpdateGroup={handleSideToggle}
              handleClosepopOver={handleClosepopOver}
              isGroupAdmin={isGroupAdmin}
              isAdminCoAdmin={isAdminCoAdmin}
              isAuditAdmin={isAuditAdmin}
              coAdminDialog={coAdminDialog}
              toggleCoAdminDialog={toggleCoAdminDialog}
              fetchChatInfo={fetchChatInfo}
              renderConversation={renderConversation}
            />
          ) : null}
        </SidePanelComponent>
      )}
      <DeleteDialog
        isOpen={isDelete}
        handleToggle={toggleDeleteDialog}
        handleSubmit={handleDelete}
        key={"Delete"}
      />
      <DeleteDialog
        isOpen={exitDialog}
        handleToggle={toggleExitDialog}
        handleSubmit={handleExit}
        key={"Exit"}
        isGroupAdmin={isGroupAdmin}
        groupMemberList={groupMemberList}
        isExit
      />
      <div>
        {(isGroupAdmin || isAuditAdmin ) && (
          <MenuItem
            className={styles.menuItem}
            onClick={() => handleSideToggle("UPDATE")}
          >
            <ListItemIcon>
              <People fontSize="small" />
            </ListItemIcon>
            <div className={styles.des}>Manage Members</div>
          </MenuItem>
        )}
        <MenuItem
          className={styles.menuItem}
          onClick={() => handleSideToggle("DETAIL")}
        >
          <ListItemIcon>
            <Info fontSize="small" />
          </ListItemIcon>
          <div className={styles.des}>Group Details</div>
        </MenuItem>
        {!isAuditAdmin && (
          <MenuItem className={styles.menuItem} onClick={toggleExitDialog}>
            <ListItemIcon>
              <ExitToApp fontSize="small" />
            </ListItemIcon>
            <div className={styles.des}>Leave</div>
          </MenuItem>
        )}

        {(isGroupAdmin || isAuditAdmin || isAdminCoAdmin) && (
          <MenuItem className={styles.deleteItem} onClick={toggleDeleteDialog}>
            <ListItemIcon>
              <Delete fontSize="small" className={styles.deleteIcon} />
            </ListItemIcon>
            <div className={styles.des}>Delete Group</div>
          </MenuItem>
        )}
        {(isGroupAdmin || isAuditAdmin || isAdminCoAdmin) && (
          <Typography variant="body2" className={styles.warningText}>
            All the data shared in the group will be deleted for all members
          </Typography>
        )}
      </div>
    </div>
  );
};

export default GroupMenu;
